// this file should be used to define route maps for routes going to the new web app
const legacyRouteMap: Record<string, { featureFlagKey: string; newRoute: string }> = {
  '/app/login': {
    featureFlagKey: 'WEB_AUTH_SIGN_IN_PAGE',
    newRoute: '/sign-in'
  },
  '/app/signup': {
    featureFlagKey: 'WEB_AUTH_SIGN_UP_PAGE',
    newRoute: '/sign-up'
  },
  '/app/signup/info': {
    featureFlagKey: 'WEB_AUTH_SIGN_UP_PAGE',
    newRoute: '/sign-up'
  },
  '/app/signup/knockknock': {
    featureFlagKey: 'WEB_AUTH_BUSINESS_SIGN_UP_PAGE',
    newRoute: '/sign-up/business'
  },
  '/app/signup/select': {
    featureFlagKey: 'WEB_AUTH_SIGN_UP_SELECT_PAGE',
    newRoute: '/sign-up'
  },
  '/app/join/invitation/:id/:token': {
    featureFlagKey: 'WEB_AUTH_SIGN_UP_INVITATION_PAGE',
    newRoute: '/sign-up/invitation/:id/:token'
  },
  '/app/join/invitation/outreach/:id/:token': {
    featureFlagKey: 'WEB_AUTH_SIGN_UP_INVITATION_PAGE',
    newRoute: '/sign-up/invitation/:id/:token'
  },
  '/app/join/invitation/fresh/:id/:token': {
    featureFlagKey: 'WEB_AUTH_SIGN_UP_INVITATION_PAGE',
    newRoute: '/sign-up/invitation/:id/:token'
  },
  '/app/signup/property-conflict': {
    featureFlagKey: 'WEB_AUTH_SIGN_UP_PROPERTY_CONFLICT_PAGE',
    newRoute: '/sign-up/property-conflict'
  },
  '/app/password/reset': {
    featureFlagKey: 'WEB_AUTH_FORGET_PASSWORD_PAGE',
    newRoute: '/password/reset'
  }
}

export default legacyRouteMap;
